import React from "react";
import styled from "styled-components";
import { getHomeSlider1 } from "../../../../api/axios";
import "./Slider1.css";
import useSWR from "swr";
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/material";

const menuData = [0, 1, 2];
const delay = 50000;

function Slider1() {
  const [index, setIndex] = React.useState(0);
  const timeoutRef = React.useRef(null);

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  React.useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(
      () =>
        setIndex((prevIndex) =>
          prevIndex === menuData.length - 1 ? 0 : prevIndex + 1
        ),
      delay
    );
    return () => {
      resetTimeout();
    };
  }, [index]);

  const { data: slideone } = useSWR(
    `getHomeSlider1`,
    async () => {
      try {
        const { data } = await getHomeSlider1();
        return data?.data?.[0];
      } catch (error) {
        console.error("error: ", error);
      }
    },
    {
      revalidateOnFocus: false,
    }
  );
  const theme = useTheme();

  return (
    <>
      <Wrapper>
        <Slideshow>
          <SlideshowSlider
            style={{ transform: `translate3d(${-index * 100}%, 0, 0)` }}
          >
            <Slide>
              <SlideDetails>
                <Box component="div" sx={{width:'100%'}}> 
                  <Image src={slideone?.image1} alt="image" />
                </Box>
                <Box>
                  <Text>{slideone?.paragraph1}</Text>
                </Box>
              </SlideDetails>
            </Slide>
            <Slide>
              <SlideDetails>
                <Box component="div">
                  <Image src={slideone?.image2} alt="image" />
                </Box>
                <Box>
                  <Text>{slideone?.paragraph2}</Text>
                </Box>
              </SlideDetails>
            </Slide>
            <Slide>
              <SlideDetails>
                <Box>
                  <Image src={slideone?.image3} alt="image" />
                </Box>
                <Box>
                  <Text>{slideone?.paragraph3}</Text>
                </Box>
              </SlideDetails>
            </Slide>
          </SlideshowSlider>
        </Slideshow>
      </Wrapper>

      <SlideshowDots>
        {menuData?.map((_, idx) => (
          <div
            style={{
              backgroundColor: `${
                index === idx ? `${theme.palette.primary.main}` : ""
              }`,
            }}
            key={idx}
            className={`slideshowDot${index === idx ? ` active` : ""}`}
            onClick={() => {
              setIndex(idx);
            }}
          ></div>
        ))}
      </SlideshowDots>
    </>
  );
}

const Wrapper = styled.div`
  height: 337px;
  margin: 0 auto;
  background: rgba(217, 217, 217, 0.17);
  border: 1px solid #06476c;
  border-radius: 30px;
  overflow: hidden;

  @media (max-width: 915px) {
    height: 100%;
    border-radius: 20px;
  }
  
  @media (max-width: 715px) {
    border-radius: 15px;
    margin: 0 10px;
  }
  
  @media (max-width: 480px) {
    border-radius: 12px;
    margin: 0 5px;
  }
  
  @media (max-width: 375px) {
    border-radius: 10px;
    margin: 0 3px;
  }
  
  @media (max-width: 320px) {
    border-radius: 8px;
    margin: 0 2px;
  }
`;

const Slideshow = styled.div`
  margin: 0 auto;
  overflow: hidden;
`;

const SlideshowSlider = styled.div`
  white-space: nowrap;
  transition: ease 1000ms;
`;

const Slide = styled.div`
  display: inline-block;
`;

const SlideDetails = styled.div`
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1.7fr;
  align-items: center;

  @media (max-width: 1165px) {
    grid-template-columns: 379px auto;
  }
  
  @media (max-width: 1040px) {
    grid-template-columns: 362px auto;
    gap: 0;
  }
  
  @media (max-width: 980px) {
    grid-template-columns: 354px auto;
  }
  
  @media (max-width: 940px) {
    grid-template-columns: auto auto;
  }
  
  @media (max-width: 915px) {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 20px;
    padding: 20px;
  }
  
  @media (max-width: 480px) {
    gap: 15px;
    padding: 15px;
  }
  
  @media (max-width: 375px) {
    gap: 10px;
    padding: 10px;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 337px;
  object-fit: cover;
  
  @media (max-width: 915px) {
    margin: 0 auto;
    // height: 250px;
    border-radius: 10px;
  }
  
  @media (max-width: 480px) {
    // height: 200px;
    border-radius: 8px;
  }
  
  @media (max-width: 375px) {
    // height: 180px;
    border-radius: 6px;
  }
  
  @media (max-width: 320px) {
    height: 160px;
    border-radius: 5px;
  }
`;

const Text = styled.p`
  color: #000000;
  line-height: 47px;
  font-size: 28px;
  font-weight: 450;
  padding: 0 39px 0 39px;
  white-space: pre-line;
  margin: 0 auto;
  max-width: 926px;

  @media (max-width: 1280px) {
    font-size: 25px;
    line-height: 40px;
  }
  
  @media (max-width: 1175px) {
    font-size: 23px;
  }
  
  @media (max-width: 1080px) {
    font-size: 21px;
    line-height: 35px;
  }
  
  @media (max-width: 915px) {
    padding: 0px 20px;
    text-align: center;
    font-size: 18px;
    line-height: 28px;
  }
  
  @media (max-width: 480px) {
    font-size: 16px;
    line-height: 24px;
    padding: 0px 15px;
  }
  
  @media (max-width: 375px) {
    font-size: 14px;
    line-height: 22px;
    padding: 0px 10px;
  }
  
  @media (max-width: 320px) {
    font-size: 13px;
    line-height: 20px;
    padding: 0px 8px;
  }
`;

const SlideshowDots = styled.div`
  text-align: center;
  padding-top: 40px;
  
  @media (max-width: 915px) {
    padding-top: 30px;
  }
  
  @media (max-width: 480px) {
    padding-top: 20px;
  }
  
  @media (max-width: 375px) {
    padding-top: 15px;
  }
  
  @media (max-width: 320px) {
    padding-top: 10px;
  }
`;

export default Slider1;
